import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import Content from './Content'

interface Props {
    isOpen: boolean
    onClose: () => void
}

function AppModal({ isOpen, onClose }: Props) {
    return (
        <Modal onClose={onClose} isOpen={isOpen} dataPointer="app_modal" size="xs" withHeaderBorder={false}>
            <Content onClose={onClose} />
        </Modal>
    )
}

export default AppModal
